/**
 * クーポンコードの正規化
 *
 * メールアドレス（normalizeEmail.ts）と同様に、スマホのフォント装飾（斜体・太字）や
 * IME の全角入力は Firestore の完全一致検索で一致せず「クーポンが見つかりません」になるため、
 * NFKC 正規化で数学用英数字・全角英数字を半角 ASCII に揃える。
 *
 * 関連: GitHub issue #3302 / Backlog DMO-358
 */
export const normalizeCouponCode = (code: string): string => {
  return code.normalize("NFKC").trim();
};
